var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.to && !_vm.$listeners.click)?_c('auth-link',_vm._g({class:_vm.cssClasses,attrs:{"to":_vm.to,"title":_vm.title}},_vm.$listeners),[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))])]):_c('span',_vm._g({class:_vm.cssClasses,attrs:{"title":_vm.title}},_vm.$listeners),[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a946d08","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CircleButton.vue
// module id = 1045
// module chunks = 0